import React, { useState } from 'react';
import { EditTwoTone } from '@ant-design/icons';
import { Modal, Form, Input, Select } from 'antd';
import { useDispatch } from 'react-redux';
import { updateCapability, fetchCapabilities } from "../../../redux/Capabilities/actions";

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export const EditCapability = ({ item }) => {
    const dispatch = useDispatch();
    const [Model_visible, setModel_visible] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        onFill();
        setModel_visible(true);
    };

    const onFill = () => {
        form.setFieldsValue(item);
    };

    const hideModal_Ok = () => {
        form.submit();
    };

    const form_onfinish = (values) => {
        dispatch(updateCapability(item._id, values)).then(() => {
            dispatch(fetchCapabilities());
        });
        form.resetFields();
        setModel_visible(false);
    };

    const hideModal_Cancel = () => {
        setModel_visible(false);
        form.resetFields();
    };

    return (
        <>
            <EditTwoTone twoToneColor='blue' onClick={showModal} />
            <Modal
                title="Edit Capability"
                visible={Model_visible}
                onOk={hideModal_Ok}
                onCancel={hideModal_Cancel}
                okText="Submit"
                cancelText="Close"
            >
                <Form
                    {...layout}
                    name="basic"
                    form={form}
                    onFinish={form_onfinish}
                >
                    <Form.Item
                        label="Capability Name"
                        name="name"
                        rules={[{ required: true, message: 'Please enter the capability name!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Capability Permission"
                        name="permission"
                        rules={[{ required: true, message: 'Please select the capability permission!' }]}
                    >
                        <Select placeholder="Select permission">
                            <Select.Option value="grant">Grant</Select.Option>
                            <Select.Option value="deny">Deny</Select.Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default EditCapability;
